module.exports = __webpack_public_path__ + "static/media/karta_vespa2.cacb5158.png";